import {
  DialogVehicleWidgetName,
  FacetTilesVehicleWidgetName,
  HeaderVehicleWidgetName,
  HomeVehicleWidgetName,
} from 'Components/names';
import requestConfig from 'Models/uiConfig/requestConfig';

export const isolatedHeader = 'isolatedHeader' as const;
export const isolatedDialog = 'isolatedDialog' as const;
export type IsolatedKey = typeof isolatedHeader | typeof isolatedDialog | null;

export type IsolatedWidgetNameRoot =
  | typeof DialogVehicleWidgetName
  | typeof HomeVehicleWidgetName
  | typeof HeaderVehicleWidgetName
  | typeof FacetTilesVehicleWidgetName;

export function getIsolatedKeyFromWidgetName(name: string): IsolatedKey {
  const [nameRoot] = name.split('_') as [IsolatedWidgetNameRoot | string];
  switch (nameRoot) {
    case DialogVehicleWidgetName:
      return isolatedDialog;
    case HomeVehicleWidgetName:
    case HeaderVehicleWidgetName:
    case FacetTilesVehicleWidgetName:
      return !requestConfig.hasSearchResults ? isolatedHeader : null;
    default:
      return null;
  }
}
